export default "__VITE_ASSET__DH4rmOhp__"